import styled from 'styled-components';

export const Container = styled.div`
  padding: 10px 20px;
  animation: fadeContentIn 0.15s ease-in-out;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.TABLET})`} {
    padding: 10px 0;
  }

  @keyframes fadeContentIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 8px;
`;

export const ItemsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const Item = styled.button`
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  padding: 6px 7px;
  border-radius: 7px;
  width: fit-content;
  border: 0;
  cursor: pointer;

  & p {
    line-height: normal;
    font-size: 16px;
    font-weight: 400;
    color: ${({ theme }) => theme.palette.D300};
    text-align: left;
  }
`;
